import type { Macro } from './types';

export const COPY = {
  title: 'Nutrition Sufficiency',
  subtitle: 'How close logged meals came to the diet plan targets, out of 100.',
  scoreHelp: {
    title: 'How the score works',
    intro: 'Each meal in the diet plan has protein, carbs and fats targets.',
    points: [
      'A macro gets full marks from 80% of its target up to 20% above it, or at least 3 g above.',
      'Below that it earns part of the mark. Well above it, it loses marks.',
      'Each meal counts in proportion to its calories, and a full day adds up to 100.',
      'A meal that is not logged scores zero.',
    ],
  },
  chartHelp: {
    title: 'Reading the chart',
    intro: 'Each bar is the score for one day, or the average for a week or month.',
    points: [
      'The colours show the points protein, carbs and fats earned, each worth up to 33.',
      'The empty top of a bar is the points missed.',
      'The shaded bands behind match the score bands.',
      'The dashed line is the average for the range.',
    ],
  },
  averageHelp: 'The average of the daily scores on days with at least one meal logged. The average score is calculated for the selected date range, excluding today.',
  daysLoggedHelp: 'Days with at least one meal logged. Days with nothing logged are left out of the average, so they do not pull it down.',
  medalDaysHelp: (medal: number) => `Days that scored ${medal} or more, out of the days logged. On each one the user earned a medal in the app.`,
  macrosHelp: {
    title: 'Macros',
    intro: 'Average eaten per day against the daily target.',
    points: [
      'The striped zone is the target range: 80% of the target up to 20% above it.',
      'The bar and its end line mark what was eaten.',
      'A day is in range when the macro lands inside the striped zone.',
    ],
  },
  chartPagePrev: 'Show earlier dates',
  chartPageNext: 'Show later dates',
  chartPageStatus: (page: number, total: number) => `Page ${page} of ${total}`,
  notLogged: 'Not logged',
  noPlan: 'No diet plan in this period',
  noPlanHint: 'Pick another range, or assign a diet plan to start scoring logged meals.',
  macrosEmpty: 'Nothing was logged in this range, so there are no macros to compare yet.',
};

export const MACRO_LABEL: Record<Macro, string> = { protein: 'Protein', carbs: 'Carbs', fats: 'Fats' };
/** Keys of the shared MacroFoodIcon glyphs. */
export const MACRO_ICON: Record<Macro, 'p' | 'c' | 'f'> = { protein: 'p', carbs: 'c', fats: 'f' };
